import { cn } from '@/lib/utils';

interface SenderWizardStepsProps {
	steps: readonly string[];
	currentIndex: number;
}

export default function SenderWizardSteps({ steps, currentIndex }: SenderWizardStepsProps) {
	return (
		<div className='flex gap-2' aria-label='Шаги мастера'>
			{steps.map((step, index) => {
				const active = index === currentIndex;
				const done = index < currentIndex;
				return (
					<div key={step} className='flex min-w-0 flex-1 flex-col gap-1'>
						<div
							className={cn(
								'h-1 rounded-full',
								active || done ? 'bg-primary' : 'bg-muted',
							)}
						/>
						<span
							className={cn(
								'truncate text-center text-[11px]',
								active ? 'text-primary' : 'text-muted-foreground',
							)}
						>
							{step}
						</span>
					</div>
				);
			})}
		</div>
	);
}
